import actions from "./actions";

const state = {};
const mutations = {};
const getters = {};

const reportModule = {
  state,
  mutations,
  actions,
  getters,
};

export default reportModule;
